import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = ['permit-status'];

const getPermitStatuses = async () => {
  return request.get(
    'Access/types/permit_statuses',
    {},
    'При получении статусов пропусков произошла ошибка'
  );
};

const usePermitStatusesQuery = (options) =>
  useQuery(key, getPermitStatuses, options);

export default usePermitStatusesQuery;
